
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errorMSUSJrUQzpUUKgAMvw6CvUkGaCq5UPuMZFD4rW8mX5IMeta } from "/usr/src/app/clients/fiu-portal/pages/error.vue?macro=true";
import { default as index1Zx_0XignDsWOMeA6PLZZ1Aa1RZaaSXBpCKoqtvGl3IMeta } from "/usr/src/app/clients/fiu-portal/pages/index.vue?macro=true";
import { default as login3KeBpOE52nhqOOhg2H8IWmuWnCw08Wzle7QbcOagqCsMeta } from "/usr/src/app/clients/fiu-portal/pages/login.vue?macro=true";
import { default as rolesBrYYYUPQXnWp4MKZMNfB4qL2_45TEtaQpObFwZIJpxmUcMeta } from "/usr/src/app/clients/fiu-portal/pages/roles.vue?macro=true";
import { default as profile1YDeJhjlG_45_EP3Sxt3HOhOKszYwh8xgE2RhXOnMUirkMeta } from "/usr/src/app/clients/fiu-portal/pages/profile.vue?macro=true";
import { default as signaturek_rnh_i3T_4585JAkdfD13t4pMtl_45e0Wsyix66bVCOGv0Meta } from "/usr/src/app/clients/fiu-portal/pages/signature.vue?macro=true";
import { default as notificationsuHjNoARPOVt1iACHPGy_45CiKQqieU35bfcew1w_45_45mbZoMeta } from "/usr/src/app/clients/fiu-portal/pages/notifications.vue?macro=true";
import { default as indexEOlztJIft2Jx_caL6HUoErBvg_45l1gL_45NGfCB49OWEqwMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/index.vue?macro=true";
import { default as search1FFHEDj0d_NF3UgKqbRuK6ZbK6ZHngJORjSAWsvddXAMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/search.vue?macro=true";
import { default as newk2OFOiwjffoP7zVwZ_4528wfqesIzvlb_Q_7P7b8atmVQMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/new.vue?macro=true";
import { default as index9EoJ6ITjxT4H_CoFjjOEFtAryQtfhIKbikZz_45wFbsr4Meta } from "/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/index.vue?macro=true";
import { default as editxW9vk0E5GG9VB7qWTPgYvSCMkZMzVYNS7oYtwgcK2dAMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/[id]/edit.vue?macro=true";
import { default as indexIsZrExpdmGFhdcBTBuFHZUVzWHaMdJdOZrx8fWj_45YsIMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/[id]/index.vue?macro=true";
import { default as indexkFm5DkHAEsQw2wRznvHkcZS_45aRDJgQ1xytKQnvotO3gMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/supplemental-report/index.vue?macro=true";
import { default as indexgYFhhVvxz_456IoMCvqkACl0BEgjv6xLU_45dTJUbu4MXUMMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/investigation-report/index.vue?macro=true";
import { default as editWlNIUaCe7lXSWl0ZUrrOLkrXRXVST_izUx5Eowc6jw4Meta } from "/usr/src/app/clients/fiu-portal/pages/reports/investigation-report/[id]/edit.vue?macro=true";
import { default as index2ilXOZQMFnLZfOoL2q4iUvCNLl7LNnCZGyzf1NSJtqMMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/supplemental-report/[id]/index.vue?macro=true";
import { default as indexBkOgW_452fRCmbOfkkAy3XcGNrJw_451oalTQlMveNIhBaIMeta } from "/usr/src/app/clients/fiu-portal/pages/reports/investigation-report/[id]/index.vue?macro=true";
export default [
  {
    name: "error",
    path: "/error",
    meta: errorMSUSJrUQzpUUKgAMvw6CvUkGaCq5UPuMZFD4rW8mX5IMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index1Zx_0XignDsWOMeA6PLZZ1Aa1RZaaSXBpCKoqtvGl3IMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login3KeBpOE52nhqOOhg2H8IWmuWnCw08Wzle7QbcOagqCsMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/login.vue")
  },
  {
    name: "roles",
    path: "/roles",
    meta: rolesBrYYYUPQXnWp4MKZMNfB4qL2_45TEtaQpObFwZIJpxmUcMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/roles.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profile1YDeJhjlG_45_EP3Sxt3HOhOKszYwh8xgE2RhXOnMUirkMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/profile.vue")
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturek_rnh_i3T_4585JAkdfD13t4pMtl_45e0Wsyix66bVCOGv0Meta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/signature.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsuHjNoARPOVt1iACHPGy_45CiKQqieU35bfcew1w_45_45mbZoMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/notifications.vue")
  },
  {
    name: "reports",
    path: "/reports",
    meta: indexEOlztJIft2Jx_caL6HUoErBvg_45l1gL_45NGfCB49OWEqwMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/index.vue")
  },
  {
    name: "reports-search",
    path: "/reports/search",
    meta: search1FFHEDj0d_NF3UgKqbRuK6ZbK6ZHngJORjSAWsvddXAMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/search.vue")
  },
  {
    name: "reports-property-sheet-new",
    path: "/reports/property-sheet/new",
    meta: newk2OFOiwjffoP7zVwZ_4528wfqesIzvlb_Q_7P7b8atmVQMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/new.vue")
  },
  {
    name: "reports-property-sheet",
    path: "/reports/property-sheet",
    meta: index9EoJ6ITjxT4H_CoFjjOEFtAryQtfhIKbikZz_45wFbsr4Meta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/index.vue")
  },
  {
    name: "reports-property-sheet-id-edit",
    path: "/reports/property-sheet/:id()/edit",
    meta: editxW9vk0E5GG9VB7qWTPgYvSCMkZMzVYNS7oYtwgcK2dAMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/[id]/edit.vue")
  },
  {
    name: "reports-property-sheet-id",
    path: "/reports/property-sheet/:id()",
    meta: indexIsZrExpdmGFhdcBTBuFHZUVzWHaMdJdOZrx8fWj_45YsIMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/property-sheet/[id]/index.vue")
  },
  {
    name: "reports-supplemental-report",
    path: "/reports/supplemental-report",
    meta: indexkFm5DkHAEsQw2wRznvHkcZS_45aRDJgQ1xytKQnvotO3gMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/supplemental-report/index.vue")
  },
  {
    name: "reports-investigation-report",
    path: "/reports/investigation-report",
    meta: indexgYFhhVvxz_456IoMCvqkACl0BEgjv6xLU_45dTJUbu4MXUMMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/investigation-report/index.vue")
  },
  {
    name: "reports-investigation-report-id-edit",
    path: "/reports/investigation-report/:id()/edit",
    meta: editWlNIUaCe7lXSWl0ZUrrOLkrXRXVST_izUx5Eowc6jw4Meta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/investigation-report/[id]/edit.vue")
  },
  {
    name: "reports-supplemental-report-id",
    path: "/reports/supplemental-report/:id()",
    meta: index2ilXOZQMFnLZfOoL2q4iUvCNLl7LNnCZGyzf1NSJtqMMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/supplemental-report/[id]/index.vue")
  },
  {
    name: "reports-investigation-report-id",
    path: "/reports/investigation-report/:id()",
    meta: indexBkOgW_452fRCmbOfkkAy3XcGNrJw_451oalTQlMveNIhBaIMeta || {},
    component: () => import("/usr/src/app/clients/fiu-portal/pages/reports/investigation-report/[id]/index.vue")
  }
]